import { useMemo } from "react";
import { LineChart } from '@mui/x-charts/LineChart';
import PropTypes from "prop-types";

const defaultMargin = { top: 20, right: 20, bottom: 20, left: 40 };

function Line3({ 
  linename1, linename2, linename3, 
  linedata1, linedata2, linedata3, 
  label, margin = defaultMargin 
}) {
  const series = useMemo(() => {
    const seriesArray = [
      {
        data: (linedata1 || []).map(n => Number(n) || 0),
        label: String(linename1 || ""),
        labelColor: "white",
        shape: "cross",
        showMark: ({ index }) => index % 2 === 0,
      },
      {
        data: (linedata2 || []).map(n => Number(n) || 0),
        label: String(linename2 || ""),
        shape: "diamond",
        showMark: ({ index }) => index % 2 === 0,
      }
    ];
    
    // Add third line if provided
    if (linename3 !== undefined || (linedata3 && linedata3.length > 0)) {
      seriesArray.push({
        data: (linedata3 || []).map(n => Number(n) || 0),
        label: String(linename3 || ""),
        shape: "circle",
        showMark: ({ index }) => index % 2 === 0,
      });
    }
    
    return seriesArray;
  }, [linedata1, linedata2, linedata3, linename1, linename2, linename3]);

  const xAxis = useMemo(() => ([{
    scaleType: "point",
    data: label || [],
    tickLabelStyle: { fill: "white" },
  }]), [label]);

  const yAxis = useMemo(() => ([{
    width: 50,
    tickLabelStyle: { fill: "white" },
  }]), []);

  return (
    <LineChart
      height={300}
      series={series}
      xAxis={xAxis}
      yAxis={yAxis}
      margin={margin}
    />
  );
}

Line3.propTypes = {
  linename1: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  linename2: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  linename3: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  linedata1: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  linedata2: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  linedata3: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  label: PropTypes.arrayOf(PropTypes.string),
  margin: PropTypes.object,
};

Line3.defaultProps = {
  linename1: "Series 1",
  linename2: "Series 2",
  linename3: undefined,
  linedata1: [],
  linedata2: [],
  linedata3: [],
  label: [],
  margin: defaultMargin,
};

export default Line3;